import React from 'react';
import Image from '../../blocks/report-image/image';

import { PDFImageProps } from '../../../utils/models';
import { preventImageCaching } from '../../../utils/utilities';

import classNames from './pdf.module.scss';

const PDFImage: React.FC<PDFImageProps> = (props): JSX.Element => {
	return (
		<div className={classNames['pdf-image']}>
			<Image src={preventImageCaching(props.src)} alt={props.caption} />

			<div className={classNames['pdf-image-caption']}>{props.caption}</div>
		</div>
	);
};

export default PDFImage;
